import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { UserService } from './user.service';

const url = environment.ruta;

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  private confirmacion: any = {
    estatus: false,
    mensaje: ''
  }

  constructor(private http: HttpClient, private userSirvice: UserService) { }

  isAuthenticated(): boolean {
    return localStorage.getItem('autenticacion_token') != null && !this.isTokenExpired();
  }

  isTokenExpired(): boolean {
    return false;
  }

  iniciarSesion(info: any) {
    const encabezado = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf8'
    })
    return this.http.post<any>(`${url}ValidarUsuario/`, info, { headers: encabezado })
      .pipe(map(resultado => {
        if (resultado && resultado.info) {
          localStorage.clear();
          // store resultado details and jwt token in local storage to keep resultado logged in between page refreshes
          localStorage.setItem('autenticacion_token', resultado.info.token);
          this.getDecodedToken();

          this.confirmacion.estatus = true;
          this.confirmacion.mensaje = resultado.mensaje;
        } else {
          this.confirmacion.estatus = false;
          this.confirmacion.mensaje = resultado.mensaje;
        }

        return this.confirmacion;
      }));
  }

  iniciarSesionFirmaElectronica(info) {
    return this.http.post<any>(`${url}ValidarFirma/`, info)
      .pipe(map(resultado => {
        if (resultado && resultado.info) {
          // store resultado details and jwt token in local storage to keep resultado logged in between page refreshes
          localStorage.setItem('autenticacion_token', resultado.info.token);
          this.getDecodedToken();

          this.confirmacion.estatus = true;
          this.confirmacion.mensaje = resultado.mensaje;
        } else {
          this.confirmacion.estatus = false;
          this.confirmacion.mensaje = resultado.mensaje;
        }

        return this.confirmacion;
      }));
  }

  logout() {
    // remove resultado from local storage to log resultado out
    localStorage.clear();
  }

  public getDecodedToken() {
    const token = localStorage.getItem('autenticacion_token');
    if (!token || this.userSirvice.getUserInfo().rol != null) 
      return null;
    try {
      const userInfo = jwtDecode<any>(token);
      const user = userInfo['userdata'];
      this.userSirvice.setUserInfo(JSON.parse(user));
    } catch (error) {
      console.error('Error al decodificar token', error);
      return null;
    }
  }
}
